import { render, staticRenderFns } from "./details-statis.vue?vue&type=template&id=a9c4e520&scoped=true"
import script from "./details-statis.vue?vue&type=script&lang=js"
export * from "./details-statis.vue?vue&type=script&lang=js"
import style0 from "./details-statis.vue?vue&type=style&index=0&id=a9c4e520&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c4e520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9c4e520')) {
      api.createRecord('a9c4e520', component.options)
    } else {
      api.reload('a9c4e520', component.options)
    }
    module.hot.accept("./details-statis.vue?vue&type=template&id=a9c4e520&scoped=true", function () {
      api.rerender('a9c4e520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statis/details-statis.vue"
export default component.exports